import { RadioButtonGroup } from '@els/els-react--radio-button';
import classNames from 'classnames';
export var selectedRadioClassName = 'c-els-radio-checked';
export var renderCourseList = function (_a) {
    var courseList = _a.courseList, selectedCourseId = _a.selectedCourseId, onSelectCourse = _a.onSelectCourse;
    return courseList.map(function (_a) {
        var _b;
        var courseId = _a.courseId, courseName = _a.courseName;
        var checked = courseId === Number(selectedCourseId);
        return (<div key={courseId} className={classNames('u-els-margin-top-1x1o2', (_b = {}, _b[selectedRadioClassName] = checked, _b))}>
        <RadioButtonGroup.Option label={courseName} value={String(courseId)} checked={checked} onChange={function (e) { return onSelectCourse(Number(e.target.value)); }}/>
      </div>);
    });
};
